import { render, staticRenderFns } from "./yxqa.vue?vue&type=template&id=24199324&scoped=true&"
import script from "./yxqa.vue?vue&type=script&lang=js&"
export * from "./yxqa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24199324",
  null
  
)

export default component.exports